<template>
  <div class="sld_order_list" style="  float: left;  width: 1000px;">
    <MemberTitle :memberTitle="L['企业认证']"></MemberTitle>
    <!-- <div class="title">企业认证</div> -->
    <div class="content">
      <el-row :gutter="20">
        <div class="list">
          <div><span style="color: #ea7c3b">*</span>{{ L['联系人姓名'] }}</div>
          <div>
            <input :placeholder="L['请输入内容']" v-model="contactName" type="text" />
          </div>
        </div>
        <div class="list">
          <div><span style="color: #ea7c3b">*</span> {{ L['企业名称'] }}</div>
          <div>
            <input :placeholder="L['请输入内容']" v-model="companyName" type="text" />
          </div>
        </div>
      </el-row>
      <el-row :gutter="20">
        <div class="list">
          <div><span style="color: #ea7c3b">*</span> {{ L['公司邮箱'] }}</div>
          <div>
            <input :placeholder="L['请输入内容']" v-model="companyEmail" type="text" />
          </div>
        </div>

        <div class="list">
          <div style="line-height: 20px; padding: 0 10px">
            <span style="color: #ea7c3b">*</span>
            {{ L['统一社会信用代码'] }}
          </div>
          <div>
            <input
              :placeholder="L['请输入内容']"
              v-model="socialCreditCode"
              type="text"
            />
          </div>
        </div>
      </el-row>
      <el-row :gutter="20">
        <div class="list">
          <div><span style="color: #ea7c3b">*</span> {{ L['开户行'] }}</div>
          <div>
            <input :placeholder="L['请输入内容']" v-model="bankName" type="text" />
          </div>
        </div>
        <div class="list">
          <div><span style="color: #ea7c3b">*</span>{{ L['银行账号'] }}</div>
          <div>
            <input :placeholder="L['请输入内容']" v-model="bankAccount" type="text" />
          </div>
        </div>
      </el-row>
      <el-row :gutter="20">
        <div class="list">
          <div><span style="color: #ea7c3b">*</span> {{ L['公司法人'] }}</div>
          <div>
            <input
              :placeholder="L['请输入内容']"
              v-model="companyLegalPerson"
              type="text"
            />
          </div>
        </div>

        <div class="list" style="margin-bottom: 0">
          <div><span style="color: #ea7c3b">*</span>  {{ L['公司地址'] }}</div>
          <div>
            <el-cascader
              class="cascader"
              ref="cascaderAddr"
              v-model="cangcat"
              :options="add"
              @change="handleChange"
              :props="cascaderProps"
              :placeholder="L['请选择']"
            ></el-cascader>
          </div>
        </div>
      </el-row>
      <el-row :gutter="20">
        <div class="list" style="display:flex;margin-left:35px;margin-top:6px">
          <div><span style="color: #ea7c3b">*</span> {{ L['详细地址'] }}</div>
          <textarea
            class="textarea"
            name=""
            id=""
            v-model="companyAddress"
            cols="30"
            rows="10"
          ></textarea>
        </div>
      </el-row>
      <div class="list" style="height: 30px"></div>
      <div class="right">
        <el-row :gutter="20">
          <div class="r_title">
            <span style="color: #ea7c3b">*</span> {{ L['营业执照'] }}
          </div>
          <img
            class="list2"
            :src="item"
            v-for="(item, index) in Oimage"
            :key="index"
            alt=""
          />
          <label for="image">
            <div class="list2"><div>+</div></div>
          </label>
          <input class="uiop" type="file" id="image" @change="getImage" />
        </el-row>
        <br />

        <div style="width: 100%; height: 1px; clear: both"></div>
        <el-row :gutter="20">
          <div class="r_title">
            <span style="color: #ea7c3b">*</span> {{ L['公司照片'] }}
          </div>
          <img
            class="list2"
            :src="item1"
            v-for="(item1, index) in Oimage2"
            :key="index"
            alt=""
          />
          <label for="image1">
            <div class="list2"><div>+</div></div>
          </label>
          <input class="uiop" type="file" id="image1" @change="getImagety" />
        </el-row>
        <br />
        <div style="width: 100%; height: 1px; clear: both"></div>
        <el-row :gutter="20">
          <div class="r_title">
            <span style="color: #ea7c3b">*</span> {{ L['产品图片'] }}
          </div>
          <img
            class="list2"
            :src="item1"
            v-for="(item1, index) in Oimage4"
            :key="index"
            alt=""
          />
          <label for="image2">
            <div class="list2"><div>+</div></div>
          </label>
          <input class="uiop" type="file" id="image2" @change="getImageapp" />
        </el-row>
        <br />
        <div style="width: 100%; height: 1px; clear: both"></div>
        <el-row :gutter="20">
          <div class="r_title">
            <span style="color: #ea7c3b">*</span> {{ L['公司网址'] }}
          </div>
          <div class="website">
            <input
              :placeholder="L['请输入内容']"
              class="input"
              v-model="value1"
              type="text"
            />
            <br />
            <input
              :placeholder="L['请输入内容']"
              class="input"
              v-model="value2"
              type="text"
            />
            <br />
            <input
              :placeholder="L['请输入内容']"
              class="input"
              v-model="value3"
              type="text"
            />
          </div>
        </el-row>
      </div>
      <div class="buttons">
        <!-- <button class="blacks">返回</button> -->
        <button class="tjrz" @click="tjrzke">{{ L['提交认证'] }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted, getCurrentInstance } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter, useRoute } from 'vue-router' //引入路由
import MemberTitle from '../../../components/MemberTitle'
export default {
  components: {
    MemberTitle
  },
  setup () {
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage();
    const route = useRoute()
    const current_state = ref('') //当前列表订单状态
    const contactName = ref('') //联系人姓名
    const companyName = ref('') //企业名称
    const router = useRouter()
    const companyEmail = ref('') //公司邮箱
    const cangcat = ref('')
    const companyAddress = ref('') //公司地址详情
    const socialCreditCode = ref('') //统一信用社
    const bankName = ref('') //开户行
    const bankAccount = ref('') //银行账号
    const companyLegalPerson = ref('') //

    const companyProvinceCode = ref('')
    const companyCityCode = ref('')
    const cascaderAddr = ref(null)
    const companyAreaCode = ref('')
    const Oimage = ref([]) //图片路径
    const Oimage1 = ref('') //图片要传的参数
    const Oimage2 = ref([]) //图片路径
    const Oimage3 = ref([]) //图片要传的参数
    const Oimage4 = ref([]) //图片路径
    const cascaderProps = {
      label: 'regionName',
      value: 'regionName',
      children: 'children'
    }
    const Oimage5 = ref([]) //图片要传的参数
    const value1 = ref('') //数组1
    const value2 = ref('') //数组1
    const value3 = ref('') //数组1
    const add = ref([]) //地址

    //提交表单

    const getImage = e => {
      proxy
        .$post(
          '/v3/oss/common/upload',
          { source: 'goods', file: e.target.files[0] },
          'form'
        )
        .then(res => {
          Oimage.value[0] = res.data.url
          Oimage1.value = res.data.path

          console.log(Oimage.value, 'Oimage2')
        })
    }
    const handleChange = e => {
      console.log(e)

      companyProvinceCode.value = e[0]
      companyCityCode.value = e[1]
      companyAreaCode.value = e[2]

      console.log(cascaderAddr.value.getCheckedNodes())
      // companyAreaCode.value = e[3];
    }
    //提交认证
    const tjrzke = () => {
      let Arr = []
      Arr.push(value1.value)
      Arr.push(value2.value)
      Arr.push(value3.value)
      let params = {}
      params.contactName = contactName.value //联系人姓名
      params.companyName = companyName.value //企业名称
      params.companyEmail = companyEmail.value //公司邮箱
      params.companyAddress = companyAddress.value //公司详细地址
      params.socialCreditCode = socialCreditCode.value //统一信用社
      params.bankName = bankName.value //开户行
      params.bankAccount = bankAccount.value //银行账号
      params.companyLegalPerson = companyLegalPerson.value //公司法人
      params.productImagesList = Oimage5.value
      params.companyImagesList = Oimage3.value
      params.businessLicense = Oimage1.value
      params.websiteList = Arr

      params.companyProvinceCode = companyProvinceCode.value
      params.companyCityCode = companyCityCode.value
      params.companyAreaCode = companyAreaCode.value
      params.areaInfo = cascaderAddr.value
        .getCheckedNodes()[0]
        .pathLabels.toString()
      console.log(params)
      //   params.receiveCountry = receiveCountry.value; //收货国家
      //   params.smsCode = smsCode.value; //验证码
      //   params.inquiryGoodsName = inquiryGoodsName.value; //品名
      //   params.contactName = contactName.value; //联系人姓名
      //   params.contactPhone = contactPhone.value; //联系人手机号
      //   params.inquiryGoodsImg = Oimage1.value.toString(); //处理图片
      //   params.enclosure = file1.value.toString(); //处理文件
      //   params.isAppointFactory = isAppointFactory.value;
      proxy
        .$post(
          '/v3/member/front/memberAttest/doCompanyAttest',
          params,
          'application/json'
        )
        .then(res => {
          if (res.state == 200) {
            router.push({
              path: `/member/index`
            })
            ElMessage(res.msg)
          }
          ElMessage(res.msg)
        })
    }
    //定义4级列表
    const addons = () => {
      proxy.$get('/v3/system/front/region/getList').then(res => {
        add.value = res.data
      })
    }
    const getImagety = e => {
      proxy
        .$post(
          '/v3/oss/common/upload',
          { source: 'goods', file: e.target.files[0] },
          'form'
        )
        .then(res => {
          Oimage2.value.push(res.data.url)
          Oimage3.value.push({
            image: res.data.path,
            isMain: 0
          })
        })
    }
    const getImageapp = e => {
      proxy
        .$post(
          '/v3/oss/common/upload',
          { source: 'goods', file: e.target.files[0] },
          'form'
        )
        .then(res => {
          Oimage4.value.push(res.data.url)
          Oimage5.value.push({
            image: res.data.path,
            isMain: 0
          })
        })
    }
    //初次渲染提示
    const shtitle = () => {
      proxy.$get('/v3/member/front/memberAttest/process').then(res => {
        console.log(res)
        if (res.data.applyStep == 0) {
          console.log(res)
        } else {
          router.push({
            path: `/member/pointOrder/orderwist`,
            query: {
              applyStep: res.data.applyStep,
              companyName: res.data.companyName
            }
          })
        }
      })
    }
    onMounted(() => {
      let shenqing = route.query.jj
      if (shenqing == 1) {
        addons()
      } else {
        addons()
        shtitle()
      }
    })
    return {
      current_state,
      contactName,
      companyName,
      companyEmail,
      companyAddress,
      socialCreditCode,
      bankName,
      bankAccount,
      companyLegalPerson,
      getImage,
      getImagety,
      getImageapp,
      handleChange,
      Oimage,
      Oimage1,
      Oimage2,
      Oimage3,
      Oimage4,
      Oimage5,
      value1,
      value2,
      value3,
      addons,
      cangcat,
      add,
      cascaderProps,
      tjrzke,
      cascaderAddr,
      L,
      companyProvinceCode,
      companyCityCode,
      companyAreaCode,
      shtitle
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../style/orderList.scss';
@import '../../../style/list2.scss';
</style>
